import { useTranslation } from "react-i18next";
import "./AboutUsDetails.scss";
import { Col, Row } from "antd";
import tournamentBgAr from "../../assets/images/tournament-bg-ar.svg";
import tournamentBgEn from "../../assets/images/tournament-bg-en.svg";
import bglogo from "../../assets/images/bg-logo.svg";
import academyBgEn from "../../assets/images/academy-bg-en.svg";
import academyBgAr from "../../assets/images/academy-bg-ar.svg";
import { useEffect } from "react";

const AboutUsDetails = () => {
  const { t, i18n } = useTranslation("common");
  const currentLanguage = i18n.language;

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <section className="about-us-detail-section">
      <div className="container">
        <div>
          <h1 className="detail-heading">
            {t("about-us-details-page.heading")}
          </h1>
          <p
            className="detail-para"
            dangerouslySetInnerHTML={{
              __html: t("about-us-details-page.description"),
            }}
          ></p>
        </div>

        <div className="content-section">
          <Row className="mobile-direction-chng" gutter={[16, 16]}>
            <Col xs={24} lg={12}>
              <h3 className="details-heading" dangerouslySetInnerHTML={{ __html: t("about-us-details-page.introduction.title") }}>
                {/* {t("about-us-details-page.introduction.title")} */}
              </h3>
              <p
                className="details-para"
                dangerouslySetInnerHTML={{
                  __html: t("about-us-details-page.introduction.description"),
                }}
              ></p>
            </Col>

            <Col xs={24} lg={12}>
              <div className="about-us-details-bg">
                <img src={bglogo} alt="loading-tournament" loading="lazy" />
              </div>
            </Col>
          </Row>
        </div>

        <div className="content-section">
          <Row gutter={[16, 16]}>
            <Col xs={24} lg={12}>
              <div className="about-us-details-bg">
                <img
                  src={
                    currentLanguage == "en" ? tournamentBgEn : tournamentBgAr
                  }
                  alt="loading-tournament"
                  loading="lazy"
                />
              </div>
            </Col>

            <Col xs={24} lg={12}>
              <h3 className="details-heading">
                {t("about-us-details-page.celebration.title")}
              </h3>
              <p className="details-para">
                {t("about-us-details-page.celebration.description")}
              </p>
            </Col>
          </Row>
        </div>

        <div className="content-section">
          <Row className="mobile-direction-chng" gutter={[16, 16]}>
            <Col xs={24} lg={12}>
              <h3
                className="details-heading"
                dangerouslySetInnerHTML={{
                  __html: t("about-us-details-page.fanzaty-academy.title"),
                }}
              >
                {/* {" "} */}
                {/* {t("about-us-details-page.fanzaty-academy.title")} */}
              </h3>
              <p
                className="details-para"
                dangerouslySetInnerHTML={{
                  __html: t(
                    "about-us-details-page.fanzaty-academy.description"
                  ),
                }}
              ></p>
            </Col>
            <Col xs={24} lg={12}>
              <div className="about-us-details-bg">
                <img
                  src={currentLanguage == "en" ? academyBgEn : academyBgAr}
                  alt="loading-tournament"
                  loading="lazy"
                />
              </div>
            </Col>
          </Row>
        </div>

        <div>
          {/* <p className="about-us-below-para">
            {t("about-us-details-page.below_heading")}
          </p> */}
        </div>
      </div>
    </section>
  );
};

export default AboutUsDetails;
